import { getClient } from "./client";
import type { ApiAppConfig } from "./shared";

export const getAppConfig = () =>
  getClient().get("/api/config").json<ApiAppConfig>();
